<bic-popup (close)="onCancel()" [hasBackdrop]="true" [title]="'Möchten Sie die Organisation '+ '“' +data.organisation.name + '”' +' verlassen?'" customClass="w-[560px] h-fit">
  <div bicPopupContent class="flex flex-col text-left">
    <span class="font-normal">Bei Bestätigung verlieren Sie mit sofortiger Wirkung den Zugriff auf sämtliche Organisationsprofile und Mitglieder.</span>
    <span class="font-normal mt-4">Um der Organisation erneut beitreten zu können, benötigen Sie die Einladung eines Administrators.</span>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    <bic-button (onClick)="onCancel()" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="leave()" buttonType="red" class="[&>button]:!bg-red-600 [&>button]:!border-red-600">Verlassen</bic-button>
  </div>
</bic-popup>
